<template>
  <div class="app-root">
    <div class="app-header-row">
      <div class="app-header-main">
        <p class="app-title">EXWE Barcode Scanner</p>
        <p v-if="!authenticated" class="lead">
          Bitte anmelden. Anschließend: Rückkamera, FaceMesh-Overlay und Live-Barcode mit
          Shopware-Artikelsuche.
        </p>
      </div>
      <div v-if="authenticated" class="app-header-actions">
        <button type="button" class="secondary btn-header-logout" @click="onLogout">Abmelden</button>
      </div>
    </div>

    <div v-if="!authenticated" class="login-panel">
      <form @submit.prevent="onLogin">
        <label for="user">Benutzername</label>
        <input id="user" v-model.trim="loginUser" name="username" autocomplete="username" />

        <label for="pass">Passwort</label>
        <input
          id="pass"
          v-model="loginPass"
          type="password"
          name="password"
          autocomplete="current-password"
        />

        <p v-if="loginError" class="error" style="margin: 0 0 12px">{{ loginError }}</p>

        <button type="submit" class="primary" :disabled="loginBusy">
          {{ loginBusy ? '…' : 'Anmelden' }}
        </button>
      </form>
    </div>

    <BarcodeScanner v-else />
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import BarcodeScanner from '@/components/BarcodeScanner.vue';
import {
  fetchAuthStatus,
  loginWithCredentials,
  logoutSession,
} from '@/services/auth.js';

const authenticated = ref(false);
const loginUser = ref('');
const loginPass = ref('');
const loginError = ref('');
const loginBusy = ref(false);

async function syncAuth() {
  authenticated.value = await fetchAuthStatus();
}

onMounted(() => {
  void syncAuth();
});

async function onLogin() {
  loginError.value = '';
  loginBusy.value = true;
  try {
    const ok = await loginWithCredentials(loginUser.value, loginPass.value);
    if (!ok) {
      loginError.value = 'Benutzername oder Passwort ungültig.';
      loginPass.value = '';
    } else {
      loginPass.value = '';
      await syncAuth();
    }
  } finally {
    loginBusy.value = false;
  }
}

async function onLogout() {
  await logoutSession();
  await syncAuth();
}
</script>
